export default "__VITE_ASSET__B_Qth50F__"